// shared-tab-data.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedTabDataService {
    private tabData = new BehaviorSubject<any>(null);

    // 可观察的数据流
    currentTabData = this.tabData.asObservable();

    // 更新数据的方法
    updateTabData(data: any) {
        this.tabData.next(data);
    }
}